(function ($) {
    if (window.matchMedia('(min-width: 960px)').matches) {
        //プライマリーメニューにサブメニュー追加

        // マウスが載ったらサブメニューを表示
        $("ul#primary-menu li").mouseenter(function () {
            $(this).siblings().find("ul").hide();  // 兄弟要素に含まれるサブメニューを全部消す。
            $(this).children().fadeIn(220);     // 自分のサブメニューを表示する。
        });

        // マウスが離れたらサブメニューを消す
        $("ul#primary-menu li").mouseleave(function () {
            $(this).parent().find("ul").fadeOut(220);
        });

        // // どこかがクリックされたらサブメニューを消す
        // $('html').click(function () {
        //     $('ul#primary-menu ul').fadeOut(220);
        // });
    }

})(jQuery);